
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';

export default {
  
  mixins: [eventTrackingMixins, lgmMixin],

  data() {
    return {
      componentRendered: false,
      promotionBannerLoadedCount: 0,
    };
  },
  
  computed: {
  },
  created() {
  },
  mounted() {
    // set next tick to wait for the product cards to be rendered
    this.$nextTick(() => {
      this.setEventTrackingListenersForProductListing()
    });
  },
  beforeRouteUpdate(to, from, next) {
    // Update event tracking listeners when the route changes
    this.$nextTick(() => {
      // this.setEventTrackingListenersForProductListing();
    });
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Set event tracking listeners when the route is entered
      vm.$nextTick(() => {
        // vm.setEventTrackingListenersForProductListing();
      });
    });
  },
  updated() {
    // Set event tracking listeners when the component's DOM is updated
    this.$nextTick(() => {
      this.setEventTrackingListenersForProductListing();
    });
  },
  

  methods: {
  
    initEventTrackingParams() {
      return {
        a: '',
        c: '',
        l: '',
        cd: {
          login_status: this.loginBoolean,
        },
      };
    },

    setEventTrackingListenersForProductListing() {
      this.eventTrackingListenersForProductListing()
    },


    eventTrackingListenersForProductListing() {
      const items = document.querySelectorAll('.product-results-container a');

      if (items) {
        const self = this
        items.forEach(function (el) {
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            el.addEventListener('click', function(e) {
              self.handleEventTracking_productListing(e)
            });
          }
        });
      }
    },

    handleEventTracking_productListing(event) {
    
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const dataFromProductMainPage = this.extractDataFromCurrentProductMainPage()
      const href = dataFromClickedElement?.href

      const eventTrackingParams = this.initEventTrackingParams()
      if (dataFromClickedElement.tracking_target.target_code === 'product-card-link') {
        // #49 decoder_card open_product_details
        const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute("data-insurer-company")
        const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute("data-product-id")
        const productName = dataFromClickedElement.offsetparent_node.getAttribute("data-product-name")
        const productCategory = dataFromProductMainPage?.product.product_category
        eventTrackingParams.a = 'open_product_details'
        eventTrackingParams.l =  productScenarioCode
        eventTrackingParams.c = `decoder_card`
        eventTrackingParams.cd = {
          insurer_name: insuranceCompany,
          product_name: productName,
          product_category: productCategory
        }

      } else if (dataFromClickedElement.tracking_target.target_code === 'product-card-cta-link-product-website') {
        // #148 product-website
        const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute("data-insurer-company")
        const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute("data-product-id")
        const productName = dataFromClickedElement.offsetparent_node.getAttribute("data-product-name")
        const productCategory = dataFromProductMainPage?.product.product_category
        eventTrackingParams.a = 'product_website'
        eventTrackingParams.l =  productScenarioCode
        eventTrackingParams.c = `decoder_card_cta`
        eventTrackingParams.cd = {
          insurer_name: insuranceCompany,
          product_name: productName,
          product_category: productCategory
        }

        this.openWindowWithLGMUrl(event, '.product-card-cta-link.product-website', eventTrackingParams, 'transitionLink');

      } else if (dataFromClickedElement.tracking_target.target_code === 'product-card-shortcut-link') {
        // #231 Click Happy Kids Certification textlink leads to Happy Kids Main Page
        const node = dataFromClickedElement.link_node.closest('.product-listing-card') || dataFromClickedElement.link_node.closest('.product-compact-card') || dataFromClickedElement.link_node.closest('.product-listing-mobile-card');
        const insuranceCompany = node.getAttribute("data-insurer-company")
        const productScenarioCode = node.getAttribute("data-product-id")
        const productName = node.getAttribute("data-product-name")
        const productCategory = dataFromProductMainPage?.product.product_category
        eventTrackingParams.a = 'to_family_site'
        eventTrackingParams.l =  productScenarioCode
        eventTrackingParams.c = `decoder_card_cta`
        eventTrackingParams.cd = {
          insurer_name: insuranceCompany,
          product_name: productName,
          product_category: productCategory
        }
      } else if (dataFromClickedElement.tracking_target.target_code === 'product-card-cta-link') {
        // #8 and #71
        if (this.isTransitionLink(href)) {
          event.preventDefault();

          // #8 to insurer page via TransitionLink
          const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute("data-insurer-company")
          const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute("data-product-id")
          const productName = dataFromClickedElement.offsetparent_node.getAttribute("data-product-name")
          const productCategory = dataFromProductMainPage?.product.product_category
          eventTrackingParams.a = 'click_redirection'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `decoder_card_cta`
          eventTrackingParams.cd = {
            insurer_name: insuranceCompany,
            product_name: productName,
            product_category: productCategory
          }

          this.openWindowWithLGMUrl(event, '.product-card-cta-link', eventTrackingParams, 'transitionLink');


        } else if (this.isWhatsappLink(href)) {
          event.preventDefault();
          // #71 url is Whatsapp link
          const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute("data-insurer-company")
          const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute("data-product-id")
          const productName = dataFromClickedElement.offsetparent_node.getAttribute("data-product-name")
          const productCategory = dataFromProductMainPage?.product.product_category
          eventTrackingParams.a = 'open_whatsapp'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `decoder_card_cta`
          eventTrackingParams.cd = {
            insurer_name: insuranceCompany,
            product_name: productName,
            product_category: productCategory
          }

          this.$goToURL(href, false, eventTrackingParams, {
            getLGMConversionId: this.getLGMConversionId,
            injectLGMConversionId: this.injectLGMConversionId,
            injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
          });
          
        } else if (this.isEComLink(href)) {
          event.preventDefault();

          // #143 url is ECom site link
          const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute("data-insurer-company")
          const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute("data-product-id")
          const productName = dataFromClickedElement.offsetparent_node.getAttribute("data-product-name")
          const productCategory = dataFromProductMainPage?.product.product_category
          eventTrackingParams.a = 'to_ecom_site'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `decoder_card_cta`
          eventTrackingParams.cd = {
            insurer_name: insuranceCompany,
            product_name: productName,
            product_category: productCategory
          }

          this.openWindowWithLGMUrl(event, '.product-card-cta-link', eventTrackingParams, 'eCommerceSite');

        } else {
          // #8 to insurer page non TransitionLink
          const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute("data-insurer-company")
          const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute("data-product-id")
          const productName = dataFromClickedElement.offsetparent_node.getAttribute("data-product-name")
          const productCategory = dataFromProductMainPage?.product.product_category
          eventTrackingParams.a = 'click_redirection'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `decoder_main_cta`
          eventTrackingParams.cd = {
            insurer_name: insuranceCompany,
            product_name: productName,
            product_category: productCategory
          }
        }

      } else if (dataFromClickedElement.tracking_target.target_code === 'product-promo-more') {
        event.preventDefault();

        // #52 open_promo_details
        const productData = this.extractDataFromCurrentProductMainPage()
        let productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-card')
          if (!productCardNode){
            productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-mobile-card')
          }
        const insuranceCompany = productCardNode.getAttribute("data-insurer-company")
        const productScenarioCode = productCardNode.getAttribute("data-product-id")
        const productName = productCardNode.getAttribute("data-product-name")
        const productCategory = productData.product.product_category
        eventTrackingParams.a = 'open_promo_details'
        eventTrackingParams.l =  productScenarioCode
        eventTrackingParams.c = `decoder_promo_banner`
        eventTrackingParams.cd.insurer_name = insuranceCompany
        eventTrackingParams.cd.product_name = productName
        eventTrackingParams.cd.product_category = productCategory


      } else if (dataFromClickedElement.tracking_target.target_code === 'product-promo-cta') {
        event.preventDefault();
        if (this.isEComLink(href)) {
          // #144 Decoder_promo_cta
          const productData = this.extractDataFromCurrentProductMainPage()
          let productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-card')
          if (!productCardNode){
            productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-mobile-card')
          }
          const insuranceCompany = productCardNode.getAttribute("data-insurer-company")
          const productScenarioCode = productCardNode.getAttribute("data-product-id")
          const productName = productCardNode.getAttribute("data-product-name")
          const productCategory = productData.product.product_category
          eventTrackingParams.a = 'to_ecom_site'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `decoder_promo_cta`
          eventTrackingParams.cd.insurer_name = insuranceCompany
          eventTrackingParams.cd.product_name = productName
          eventTrackingParams.cd.product_category = productCategory

          this.openWindowWithLGMUrl(event, '.product-promo-cta', eventTrackingParams, 'eCommerceSite');
        } else if (this.$isWhatsappLink(href)) {
          // #144a Decoder_promo_cta
          const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
          const productData = this.extractDataFromCurrentProductMainPage()
          let productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-card')
          if (!productCardNode){
            productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-mobile-card')
          }
          const insuranceCompany = productCardNode.getAttribute("data-insurer-company")
          const productScenarioCode = productCardNode.getAttribute("data-product-id")
          const productName = productCardNode.getAttribute("data-product-name")
          const productCategory = productData.product.product_category
          eventTrackingParams.a = 'open_whatsapp'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `decoder_promo_cta`
          eventTrackingParams.cd.insurer_name = insuranceCompany
          eventTrackingParams.cd.product_name = productName
          eventTrackingParams.cd.product_category = productCategory

          this.$goToURL(dataFromClickedElement.href, false, eventTrackingParams, {
            getLGMConversionId: this.getLGMConversionId,
            injectLGMConversionId: this.injectLGMConversionId,
            injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
          });


        } else {
          // #9 product_details_promo_cta
          const productData = this.extractDataFromCurrentProductMainPage()
          let productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-card')
          if (!productCardNode){
            productCardNode = dataFromClickedElement.offsetparent_node.closest('.product-listing-mobile-card')
          }
          const insuranceCompany = productCardNode.getAttribute("data-insurer-company")
          const productScenarioCode = productCardNode.getAttribute("data-product-id")
          const productName = productCardNode.getAttribute("data-product-name")
          const productCategory = productData.product.product_category
          eventTrackingParams.a = 'click_redirection'
          eventTrackingParams.l =  productScenarioCode
          eventTrackingParams.c = `decoder_promo_cta`
          eventTrackingParams.cd.insurer_name = insuranceCompany
          eventTrackingParams.cd.product_name = productName
          eventTrackingParams.cd.product_category = productCategory

          this.openWindowWithLGMUrl(event, '.product-promo-cta', eventTrackingParams, 'transitionLink');

        }

      }

      this.sendEventTracking(eventTrackingParams)
    },

    

  },
  
};